import type { z } from 'zod';
import { genderCodeSchema } from '@/consts/backend-i18n-derived';
import { zodRemoveNullable } from '@/lib/zod-helper';
import {
  type QueryPatientCardRes,
  queryExamRoomReportByIdResSchema,
  queryImageReportByIdResSchema,
  queryLabReportByIdResSchema,
  queryPathologyReportContentResSchema,
  queryPatientCardResSchema,
  querySurgeryReportContentResSchema,
} from '~/generated/cdr/zod-schema';

const patientCardPatientSchema = zodRemoveNullable(queryPatientCardResSchema, {
  excludeMask: { isolationFlag: true, fastingFlag: true },
}).extend({
  genderI18n: genderCodeSchema,
} satisfies Partial<
  Record<keyof typeof queryPatientCardResSchema.shape, z.ZodType>
>);

export type PatientCardResponse = z.infer<typeof patientCardPatientSchema>;

export const parsePatientCard = (data: QueryPatientCardRes | null) =>
  patientCardPatientSchema.parse(data);

export const cdrLabReportHeaderSchema = zodRemoveNullable(
  queryLabReportByIdResSchema.omit({ labReportDetails: true }),
  {
    excludeMask: {
      orderDatetime: true,
      orderDoctorName: true,
      category: true,
      categoryI18n: true,
    },
  },
);

export const cdrReportSchemas = {
  surgery: zodRemoveNullable(querySurgeryReportContentResSchema, {
    excludeMask: { requisitionNo: true },
  }),
  image: zodRemoveNullable(queryImageReportByIdResSchema, {
    excludeMask: { requisitionNo: true },
  }),
  exam: zodRemoveNullable(queryExamRoomReportByIdResSchema, {
    excludeMask: { requisitionNo: true },
  }),
  pathology: zodRemoveNullable(queryPathologyReportContentResSchema, {
    excludeMask: { requisitionNo: true },
  }),
};
